import { useState} from 'react';
import { motion } from 'framer-motion';
import { DaysSelect } from './days-select';
import { HoursInput } from './hours-select';
import { useSettings } from '../../../../app/context/settings-context/settings-context';


export const When = () => {

    const {schedule} = useSettings(); 

   

    const [otherDay, setOtherDay] = useState(false);

    const [currentDate, setCurrentDate] = useState(false);

   

    const handleChange = (e) => {
        e.target.value === 'other-day' ?  setOtherDay(true) : setOtherDay(false);
    };

    if (Object.keys(schedule()).length === 0) {
        return null;
    }

    return (
        <div className="mb-3">
            <label  className="form-label fs-6 fw-bold">Коли?</label>
            <div className="input-group mb-3">
                <select onChange={handleChange} defaultValue={`today`} className="form-select  fw-bold">
                    <option value="today">Вже</option>
                    <option value="other-day">Обрати час</option>
                </select>
            </div>
            {otherDay && 
                 <motion.div className="row"
                    initial={{opacity: 0}}
                    animate={{opacity: 1, translate: { duration: 0.7 }}}
                    exit={{opacity: 0, translate: { duration: 0.1 }}}
                 >
                    <DaysSelect props={{schedule}} setCurrentDate={setCurrentDate}/>
                    <HoursInput props={{currentDate, schedule}}/>
                </motion.div>
            }
            
        </div>
    )    
}